import { render } from "./ModuleActingAppointment.vue?vue&type=template&id=62be90ef"
import script from "./ModuleActingAppointment.vue?vue&type=script&lang=js"
export * from "./ModuleActingAppointment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__